import { AbstractControl, ValidatorFn } from '@angular/forms';
import { OperationType } from '../enum/operation-type.enum';
import { IBank } from '../interfaces/bank.interface';
import { IOperation } from '../interfaces/operation.interface';

export const DigitalWalletValidator = (
    bank: IBank,
    operation: IOperation,
    amount?: number
): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (bank && operation) {
            if (bank?.digitalWallet && operation.type === OperationType.BUY) {
                return {
                    digitalWalletNotBuy: {
                        name: bank.short,
                        type: OperationType.BUY,
                    },
                };
            }

            if (bank?.digitalWallet && +amount > +bank?.maxAmount) {
                return {
                    digitalWalletMaxAmount: {
                        maxAmount: bank.maxAmount,
                    },
                };
            }

            if(bank?.minAmount && +bank?.minAmount > +amount){
                return{
                    minAmountValid: {
                        minAmount: bank.minAmount,
                    }
                };
            }
        }

        return null;
    };
};
